import React, {JSX, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { autorun, IReactionDisposer } from "mobx";
import { ContextMenuStore } from "../../store/ContextMenuStore";
import './ContextMenu.styles.scss';

export type ContextMenuOption = {
    title: string;
    icon?: () => JSX.Element;
    onClick?: () => void;
};

// This assumes <ve-portal> is either a custom element already registered, or replaced with a real portal in your app
const ContextMenu = observer(() => {
    const [position, setPosition] = React.useState(ContextMenuStore.position);
    const [options, setOptions] = React.useState(ContextMenuStore.options);
    const disposeRef = React.useRef<IReactionDisposer | null>(null);

    useEffect(() => {
        // Sync mobx to local state
        disposeRef.current = autorun(() => {
            setPosition(ContextMenuStore.position);
            setOptions(ContextMenuStore.options);
        });

        // Hide on outside click
        const handleClickOutside = () => {
            ContextMenuStore.hide();
        };
        document.addEventListener("click", handleClickOutside);

        return () => {
            disposeRef.current?.();
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    if (position == null) return null;

    const { x, y } = position;
    const style: React.CSSProperties = {
        width: "185px",
        position: "fixed",
        left: `${x}px`,
        top: `${y}px`,
    };

    return (
            <div className="context-menu__content" style={style}>
                {options.map((item, index) => (
                    <div key={"cm" + index} className="context-menu__content-option" onClick={item.onClick}>
                        {item.icon?.()}
                        <p className="context-menu__content-option-title">{item.title}</p>
                    </div>
                ))}
            </div>
    );
});

export default ContextMenu;